<template>
    <b-form-checkbox
        :button="button"
        :checked="checked"
        :disabled="disabled"
        :indeterminate="indeterminate"
        :inline="inline"
        :plain="plain"
        :required="required"
        :size="size"
        :state="state"
        :unchecked-value="uncheckedValue"
        :value="value"
        @change="$emit('change', $event)"
        @input="$emit('input', $event)"
        :class="['form-input-checkbox', {'placeholder-label': label === false }]"
    >
        <slot />
    </b-form-checkbox>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'

export default {
    components: { BFormCheckbox },
    computed: {
        size() {
            return this.small ? 'sm' : (this.large ? 'lg' : (''))
        }
    },
    created() {
        if (this.validator) {
            this.$validator = this.validator
        }
    },
    inject: {
        validator: { default: null, from: 'validator' }
    },
    model: { prop: 'checked', event: 'input' },
    props: {
        button: { type: Boolean },
        checked: { type: [Array, Boolean, String, Number, Object] },
        disabled: { type: Boolean },
        indeterminate: { type: Boolean },
        inline: { type: Boolean },
        label: { type: [String, Boolean], default: '' },
        large: { type: Boolean },
        plain: { type: Boolean },
        required: { type: Boolean },
        small: { type: Boolean },
        state: { type: Boolean, default: null },
        uncheckedValue: { type: [Array, Boolean, String, Number, Object], default: false },
        value: { type: [Array, Boolean, String, Number, Object], default: true },
    }
}
</script>